<style type="text/css">
  .t4Property .propLabel {
    display: inline-block;
    width: 125px
  }

  .t4Property .propValue {
    display: inline-block;
    max-width: 125px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
</style>
<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
@if(isLoading) {
<ng-container>
  <mat-spinner style="margin:auto"></mat-spinner>
</ng-container>
}
@if(!isLoading) {
<ng-container>
  <mat-dialog-content>
    @if(actionType == 'existing') {
    <ng-container>
      @if(customer?.Type == customerType?.Consumer) {
      <h2 mat-mdc-dialog-title>{{ customer.Firstname}} {{ customer.Lastname}}</h2>
      }
      @if(customer?.Type == customerType?.Company) {
      <h2 mat-mdc-dialog-title>{{ customer.CompanyName}}</h2>
      }

      <mat-tab-group animationDuration="0ms" style="height:620px;" #customerTabs>
        <mat-tab label="{{ 'Turbo.CustomerDialog.headCustomerInfo' | translate:'Customer Info'}}">
          <t4-container style="padding-top: 35px;">
            <div class="row" style="padding-top: 40px;">

              <t4-RentalCustomerDetails #frmCustomerInfo
                                        [customer]="customer"
                                        [clientSettingsForm]="clientSettingsForm">
              </t4-RentalCustomerDetails>
            </div>
            @if(customer.Blocked) {
            <div class="=row" style="text-align:center">
              @if(customer.Blocked) {
              <span style="color: red;">{{ 'Turbo.CustomerDialog.msgCustomerBlocked' | translate:'Customer is disabled'}} <mat-icon matTooltip="{{ customer.BlockedReason }}">help</mat-icon></span>
              }
            </div>
            }
          </t4-container>
        </mat-tab>
        <mat-tab label="{{ 'Turbo.CustomerDialog.headSettings' | translate:'Settings'}}">
          <t4-container>
            <div>
              <form [formGroup]="blockedForm">
                <mat-checkbox formControlName="Blocked"
                              labelPosition="before">
                  Blocked:
                </mat-checkbox>

                <mat-form-field appearance="outline">

                  <mat-label>Reason:</mat-label>
                  <textarea #reasonTextArea
                            formControlName="BlockedReason"
                            matInput
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="10"></textarea>
                </mat-form-field>
              </form>
            </div>
          </t4-container>
          @if(customer && customer.Type == customerType?.Company) {
          <t4-container title="{{ 'Turbo.CustomerDialog.InvoiceSettings' | translate:'Invoice settings' }}">
            <div>
              <mat-slide-toggle style="margin: 0px 15px;" [(ngModel)]="customer.AllowInvoicing">{{ 'Turbo.CustomerDialog.lblAllowInvoicing' | translate : 'Allow invoicing' }}</mat-slide-toggle>
              @if(customer && customer.AllowInvoicing) {
              <ng-container>
                <div class="container">
                  <div class="row align-items-center">
                    <div class="col-md-9">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Turbo.CustomerDialog.lblInvoiceCustomerNumber' | translate : 'Invoice customer number' }}</mat-label>
                        <input matInput type="text" [(ngModel)]="customer.CustomerNumber" (ngModelChange)="onCustomerNumberChange()" />
                      </mat-form-field>
                    </div>
                    <div class="col-md-3">
                      <button mat-raised-button color="primary" [disabled]="isCustomerValidated" (click)="validateCustomerNumber()">{{ 'Turbo.CustomerDialog.cmdValidate' | translate : 'Validate' }}</button>
                    </div>
                  </div>
                  <div *ngIf="!isvalidCustomerNumber" class="row align-items-center">
                    <div class="col">
                      <div class="warning-message text-danger">
                        {{ 'Turbo.CustomerDialog.lblCustomerNumberInvalid' | translate : 'Customer number is not valid.' }}
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!isCustomerValidated" class="row align-items-center">
                    <div class="col">
                      <div class="warning-message text-danger">
                        {{ 'Turbo.CustomerDialog.lblCustomerNumberWarning' | translate : 'Customer number is not validated. Please validate to setup invoicing.' }}
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-9">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Turbo.CustomerDialog.lblInvoiceCode' | translate : 'Invoice code' }}</mat-label>
                        <input matInput type="text" readonly [(ngModel)]="customer.InvoiceCode" />
                      </mat-form-field>
                    </div>
                    <div class="col-md-3">
                      <button mat-raised-button color="primary" (click)="regenerateCode()">{{ 'Turbo.CustomerDialog.cmdRegenerate1' | translate : 'Regenerate' }}</button>
                    </div>
                  </div>
                </div>
              </ng-container>
              }
            </div>
          </t4-container>
          }
        </mat-tab>
        <mat-tab label="{{ 'Turbo.RentalObject.headEvents' | translate:'Latest events'}}">
          <t4-container loadingMessage="{{ 'Turbo.CustomerDialog.LoadingMessage' | translate:'Loading customer history' }}" [isLoading]="loading.isLoading">
            @if(loading.isLoading) {
            <div class="cover"></div>
            }
            @if(customer) {
            <div class="row">
              @for(item of rentals; track item) {
              <div class="list-item" [ngClass]="{ 'lateResource': item.Status == 1 }">
                <div>
                  @if(item.Status == 1) {
                  <div style="float: left;text-align: center; margin: 0px 6px; text-align: center; color:#e52a16"><mat-icon>clear</mat-icon><br />&nbsp;</div>
                  }
                  @if(item.Status != 1) {
                  <div style="float: left; text-align: center; margin: 5px 6px;"><div class="statusIcon" style="margin-bottom: 9px;" [ngClass]="{'status-green': item.Status == 200, 'status-red': (item.Status == 150), 'status-yellow': (item.Status == 100), 'status-lightgreen': (item.Status == 50) }"></div><mat-icon>person</mat-icon></div>
                  }
                  <t4-booking-link bookingId="{{item.Id}}" style="float: right;"></t4-booking-link>
                  <div><mat-icon style="margin-right: 5px;">flight_land</mat-icon><span style="display: inline-block; min-width: 50px;">{{ item.ReturnTime | date : 'yyMMdd' }}</span><span> {{ item.ReturnLocation?.Name }}</span></div>
                  <div style="margin-top: 5px;"><mat-icon style="margin-right: 5px;">flight_takeoff</mat-icon><span style="display: inline-block; min-width: 50px;">{{ item.PickupTime | date : 'yyMMdd' }}</span><span> {{ item.PickupLocation?.Name }}</span></div>
                </div>
              </div>
              }
            </div>
            }
          </t4-container>
        </mat-tab>
        @if(customer && customer.Type == customerType?.Company && invoiceRentals && invoiceRentals.length > 0) {
        <mat-tab label="{{ 'Turbo.RentalObject.headInvoiceRentals' | translate:'Invoice rentals'}}">
          <t4-container loadingMessage="{{ 'Turbo.CustomerDialog.LoadingInvoiceMessage' | translate:'Loading invoice rental history' }}" [isLoading]="loading.isLoading">
            @if(loading.isLoading) {
            <div class="cover"></div>
            }
            @if(customer) {
            <t4-data-table [allowFilter]="false" [rawData]="invoiceRentals" matSort matSortActive="StartTime" matSortDirection="desc" [allowExcel]="false" [autoGenerateColumns]="false" [filterFields]="['Id', 'UserEmail', 'StartDate', 'EndDate', 'Price']">
              <ng-container matColumnDef="Id">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 50px;">{{ 'Turbo.Core.CustomerDialog.colRentalId' |translate : 'Rental Id' }}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 50px;">
                  <t4-booking-link bookingId="{{row.Id}}"></t4-booking-link>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="StartDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; justify-content: center; min-width: 50px;">{{ 'Turbo.Core.CustomerDialog.colStartDate' |translate : 'Start date' }}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; justify-content: center; min-width: 50px;">
                  {{row.PickupTime | date : 'yyyy-MM-dd' }}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="EndDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; justify-content: center; min-width: 50px;">{{ 'Turbo.Core.CustomerDialog.colEndDate' |translate : 'End date' }}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; justify-content: center; min-width: 50px;">
                  {{row.ReturnTime | date : 'yyyy-MM-dd' }}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="Price">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; justify-content: center; min-width: 50px;">{{ 'Turbo.Core.CustomerDialog.colPrice' |translate : 'Price' }}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; justify-content: center; min-width: 50px;">
                  {{row.Price?.DiscountedTotalPrice | currency }}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="UserEmail">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; justify-content:center; min-width:200px;">{{ 'Turbo.Core.CustomerDialog.colUserEmail' |translate : 'User email' }}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; justify-content: left; min-width: 200px;" matTooltip="{{row.Customer?.Email}}">
                  {{row.Customer?.Email}}
                </mat-cell>
              </ng-container>
            </t4-data-table>            
            }
          </t4-container>
        </mat-tab>
        }
        <mat-tab label="{{ 'Turbo.CustomerDialog.headNotes' | translate:'Notes'}}">
          <t4-container>
            <div class="col-xs-12">
              <mat-form-field style="width: 100%">
                <textarea #txtComments="ngModel" matInput placeholder="{{ 'turbo.core.RentalDialog.Notes' | translate : 'Notes'}}" [(ngModel)]="customer.Notes" matTextareaAutosize matAutosizeMinRows="9" matAutosizeMaxRows="9"></textarea>
              </mat-form-field>
            </div>
          </t4-container>
        </mat-tab>
      </mat-tab-group>
    </ng-container>
    }
    @else if(actionType == 'new') {
    <ng-container>
      <h2>{{ 'Turbo.CustomerDialog.NewCustomer' | translate : 'New customer'}}</h2>
      <t4-container style="padding-top: 35px;">
        <div class="row" style="padding-top: 40px;">
          <t4-RentalCustomerDetails #frmCustomerInfo
                                    [customer]="customer"
                                    [clientSettingsForm]="clientSettingsForm"
                                    rentalCustomerType="Company">
          </t4-RentalCustomerDetails>
        </div>
      </t4-container>
    </ng-container>
    }

    <!--<t4-container loadingMessage="{{ 'Turbo.CustomerDialog.LoadingMessage' | translate:'Loading customer history' }}" [isLoading]="loading.isLoading" title="{{ 'Turbo.CustomerDialog.lblDetails' | translate:'Details' }}">
    <div class="cover" *ngIf="loading.isLoading"></div>
    <div class="row" *ngIf="customer">
      <div class="col-xs-12">
        <mat-tab-group style="height: 250px; clear: both;">
          <mat-tab label="{{ 'Turbo.RentalObject.headEvents' | translate:'Latest events'}}">
            <div class="list-item" [ngClass]="{ 'lateResource': item.Status == 1 }" *ngFor="let item of rentals">
              <div>
                <div style="float: left;text-align: center; margin: 0px 6px; text-align: center; color:#e52a16" *ngIf="item.Status == 1"><mat-icon>clear</mat-icon><br />&nbsp;</div>
                <div style="float: left; text-align: center; margin: 5px 6px;" *ngIf="item.Status != 1"><div class="statusIcon" style="margin-bottom: 9px;" [ngClass]="{'status-green': item.Status == 200, 'status-red': (item.Status == 150), 'status-yellow': (item.Status == 100), 'status-lightgreen': (item.Status == 50) }"></div><mat-icon>person</mat-icon></div>
                <t4-booking-link bookingId="{{item.Id}}" style="float: right;"></t4-booking-link>
                <div><mat-icon style="margin-right: 5px;">flight_land</mat-icon><span style="display: inline-block; min-width: 50px;">{{ item.ReturnTime | date : 'yyMMdd' }}</span><span> {{ item.ReturnLocation?.Name }}</span></div>
                <div style="margin-top: 5px;"><mat-icon style="margin-right: 5px;">flight_takeoff</mat-icon><span style="display: inline-block; min-width: 50px;">{{ item.PickupTime | date : 'yyMMdd' }}</span><span> {{ item.PickupLocation?.Name }}</span></div>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="{{ 'Turbo.CustomerDialog.headSettings' | translate:'Settings'}}" style="min-height: 190px;" *ngIf="false">
            <div class="col-xs-12" style="min-height: 190px;">
              <div class="col-xs-5" style="margin-top: 15px">
                <mat-form-field>
                  <mat-label>{{ 'turbo.core.CustomerDialog.lblPaymentType' | translate : 'Payment type'}}</mat-label>
                  <mat-select [value]="customer.Payment" (valueChange)="changePaymentType($event)">
                    <mat-option [value]="0">{{ 'turbo.core.CustomerDialog.PaymentType_Standard' | translate : 'Standard'}}</mat-option>
                    <mat-option [value]="1">{{ 'turbo.core.CustomerDialog.PaymentType_Invoice' | translate : 'Invoice'}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-xs-7" style="margin-top: 20px; text-align: right">
                <span>
                  <mat-checkbox #chkBlockCustomer [checked]="customer.Blocked" (change)="blockCustomer($event)">{{ 'turbo.core.customerDialog.chkBlockCustomerExpl' | translate : 'Block this customer from renting trailers'}}</mat-checkbox>
                </span>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="{{ 'Turbo.CustomerDialog.headNotes' | translate:'Notes'}}">
            <div class="col-xs-12">
              <mat-form-field style="width: 100%">
                <textarea #txtComments="ngModel" matInput placeholder="{{ 'turbo.core.RentalDialog.Notes' | translate : 'Notes'}}" [(ngModel)]="customer.Notes" matTextareaAutosize matAutosizeMinRows="9" matAutosizeMaxRows="9"></textarea>
              </mat-form-field>
            </div>
          </mat-tab>

        </mat-tab-group>

      </div>
    </div>
  </t4-container>-->

    <mat-menu #menu="matMenu">
      <ng-template matMenuContent>
        <button mat-menu-item (click)="deletePersonalInfo()"> {{ 'Turbo.CustomerDialog.RemovePersonalInfo' | translate : 'Remove personal information'}}</button>
      </ng-template>
    </mat-menu>
  </mat-dialog-content>
  <mat-dialog-actions style="box-sizing: border-box">
    @if(actionType == 'existing') {
    <ng-container>
      <div style="text-align: left;" class="col-xs-4">
        <button mat-icon-button [matMenuTriggerFor]="menu" [matMenuTriggerData]="{ customer: customer }" (click)="$event.stopPropagation();">
          <mat-icon>more_vert</mat-icon>
        </button>
        <button mat-stroked-button color="primary" style="margin: 3px;" (click)="blockCustomerClick()"> {{ 'turbo.core.CustomerDialog.cmdBlock' | translate : 'Block customer'}} </button>
      </div>

      <div class="col-xs-8" style="text-align: right">
        <button mat-flat-button color="primary" style="margin: 3px;" [disabled]="(blockedForm?.get('Blocked').value && blockedForm?.get('BlockedReason').invalid) || (customer && customer.Type == customerType?.Company && !isCustomerValidated)" (click)="save(true)">{{ 'turbo.core.CustomerDialog.cmdSave' | translate : 'Save'}}</button>
        <button mat-stroked-button color="primary" style="margin: 3px;" [mat-dialog-close]>{{ 'turbo.core.CustomerDialog.cmdCancel' | translate : 'Cancel'}}</button>
      </div>
    </ng-container>
    }
    @else if(actionType == 'new') {
    <ng-container>
      <div class="col-xs-8" style="text-align: right">
        <button mat-flat-button color="primary" style="margin: 3px;" (click)="createCustomer()">{{ 'turbo.core.CustomerDialog.cmdSave' | translate : 'Save'}}</button>
        <button mat-stroked-button color="primary" style="margin: 3px;" [mat-dialog-close]>{{ 'turbo.core.CustomerDialog.cmdCancel' | translate : 'Cancel'}}</button>
      </div>
    </ng-container>
    }
  </mat-dialog-actions>
</ng-container>
}

